import React, { memo, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import $ from 'jquery';

import { Onboard } from '@shared/ui/Onboard';
import { UiText } from '@shared/ui/UiText';

import cls from './Notification.module.css';
import { NotificationBody } from './NotificationBody/NotificationBody';
import { NotificationHeader } from './NotificationHeader/NotificationHeader';
import { SystemNotificationsModal } from './SystemNotificationsModal/SystemNotificationsModal';
import { useNotification } from './useNotification';

interface NotificationProps {
    classes?: string;
}

export const Notification = memo(({ classes }: NotificationProps) => {
    const {
        isOpen,
        onClose,
        isOpenSystem,
        systemModalContent,
        onCloseModalSystem,
        onOpenModalSystem,
        needFetch,
    } = useNotification();

    const [distanceToRight, setDistanceToRight] = useState(0);

    useEffect(() => {
        const $element = $('[data-action="notification"]');
        const distanceToRight =
            $(window).width() - ($element.offset().left + $element.outerWidth());

        setDistanceToRight(distanceToRight);
    }, []);

    return (
        <>
            {isOpenSystem && (
                <SystemNotificationsModal
                    isOpen={isOpenSystem}
                    onHide={onCloseModalSystem}
                    systemModalContent={systemModalContent}
                />
            )}
            {isOpen && (
                <div
                    style={{ right: 32 - distanceToRight }}
                    className={classNames(cls.Notification, classes)}
                    onClick={(event) => event.stopPropagation()}
                >
                    <NotificationHeader />
                    <NotificationBody
                        needFetch={needFetch}
                        onClose={onClose}
                        onOpenModalSystem={onOpenModalSystem}
                    />
                </div>
            )}
            {!!$(`#finance_export_requests`).length && (
                <Onboard
                    isLeft
                    text="Экспортированный отчет появился в «Готовых отчетах»"
                    localStorageKey="finance_export_requests"
                    elementId="finance_export_requests"
                    elementContent={
                        <UiText variant="mediumPlain" weight="bold" tag="span">
                            Готовые файлы отчетов
                        </UiText>
                    }
                    elementHeight={49}
                    elementWidth={40}
                />
            )}
        </>
    );
});
